// extracted by mini-css-extract-plugin
export default {"succesBox":"SuccessMessage_succesBox__XZ+GY"};